export default __webpack_public_path__ + "static/media/linkedin.17785dd2.svg";